import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RouteBuilder } from 'routing';
import PropTypes from 'prop-types';

import logo from 'assets/images/logo.jpg';
import logo_horizontal from 'assets/images/logo_long_horizontal.png';

import { ToastContainer } from 'react-toastify';
// CSS is auto-injected in react-toastify v11+
import ToastifyNotification from 'components/UI/Notifications/ToastifyNotification';
import { Card } from '@mui/material';

import Api from 'Api';
import './EmptyLayout.scss';
import { isEmpty } from '@lsgo/lsgo-common/utils';
import { logOutTeacher } from 'store/actions/authActions';
import store from 'store';

/**
 *@returns JSX
 */
const EmptyLayout = ({ component: Component, auth, serverNotifications, ...rest }) => {
    const location = useLocation();
    const [release, setRelease] = useState(null);
    const [toastType, setToastType] = useState(null);
    //notify the master template to the page type
    document.body.classList.toggle('account-pages', true);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const pathname = location.pathname;

    useEffect(() => {
        async function fetchVersion() {
            const newRelease = await Api.getVersion();

            setRelease(newRelease);
        }
        // fetchVersion();
    }, []);

    useEffect(() => {
        if (!isEmpty(serverNotifications.message)) {
            serverNotifications.type === 'warning'
                ? setToastType('server-notification warning-notification')
                : setToastType('server-notification success-notification');
        }
    }, [serverNotifications]);

    return (
        <Fragment>
            <div className={`lsgo-empty-layout container-fluid ${pathname === '/trial' ? 'is-trial' : ''}`}>
                <div className={`empty-component-holder `}>
                    <Card className='component-card'>
                        <h2 className='text-uppercase text-center'>
                            <a href='/' className='text-success'>
                                <span>
                                    <img
                                        src={
                                            pathname === '/trial' || (pathname && pathname.includes('/teacher/verify'))
                                                ? logo_horizontal
                                                : logo
                                        }
                                        alt='lsgo'
                                        style={{ maxWidth: 250, height: 'auto', maxHeight: 100 }}
                                    />
                                </span>
                            </a>
                        </h2>
                        <RouteBuilder
                            type={
                                rest.type || (rest.schoolBytesUnsafeRoute || rest.sentralUnsafeRoute ? 'sso' : 'guest')
                            }
                            ssoType={
                                rest.schoolBytesUnsafeRoute
                                    ? 'schoolBytes'
                                    : rest.sentralUnsafeRoute
                                      ? 'sentral'
                                      : undefined
                            }
                            {...rest}
                            render={(props) => <Component {...props} />}
                        />
                    </Card>
                </div>

                <div className='row text-center empty-footer'>
                    <div id='versionNumber' className='col-sm-6'>
                        <a
                            href='https://help.lifeskillsgo.com/en/articles/15998621-life-skills-go-change-list'
                            target='_blank'
                            rel='noopener noreferrer'
                            style={{ display: 'block' }}
                        >
                            <span>Version: v2026.01.01</span>
                        </a>
                        <span style={{ display: 'block' }}>{currentYear} &copy; Life Skills Group Online Pty Ltd.</span>
                    </div>

                    <div className='col-sm-6'>
                        <a
                            href='https://www.facebook.com/groups/GOusers/'
                            className='cursor'
                            target='_blank'
                            rel='noopener noreferrer'
                            style={{ display: 'block' }}
                        >
                            <i className='fab fa-facebook-square' style={{ verticalAlign: 'middle' }} /> &nbsp; Join our
                            teacher community!
                        </a>

                        <a
                            href='https://www.lifeskillsgroup.com.au/terms-and-conditions'
                            target='_blank'
                            rel='noopener noreferrer'
                            style={{ display: 'block' }}
                        >
                            <span>Terms and Conditions</span>
                        </a>
                        <div>
                            <button
                                style={{ backgroundColor: 'white', color: 'black' }}
                                onClick={async () => {
                                    console.log('clearing cache');
                                    localStorage.removeItem('authToken');
                                    localStorage.removeItem('lsgoRT');
                                    store.dispatch(logOutTeacher());
                                    // props.history.push('/login');
                                    window.location.reload();
                                }}
                            >
                                Clear Cache
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <ToastifyNotification />
                <ToastContainer toastClassName={toastType} autoClose={false} closeOnClick={false} />
            </div>
        </Fragment>
    );
};

EmptyLayout.propTypes = {
    component: PropTypes.func.isRequired,
};

export default connect((state) => {
    return { auth: state.auth, serverNotifications: state.ui.serverNotifications };
})(EmptyLayout);
